let Environment = {
  nftPurchase: "0xcaE4fB5cdA5f679c6dB7A7A4b2b08F1A4E6b59Ac", // BSC chain address,
  API_URL: "https://api-smartcity.quecko.org/",
  UserDashboard: "https://rwa-staging-user.narsunprojects.com/",
  // API_URL:'http://192.168.30.183:8088/'
};
export default Environment;
